<template>
  <div class="sidebar-form">
    <section class="sidebar-form__section" style="view-transition-name: sidebar-form__section--photo">
      <div class="sidebar-form__section-head">
        <h2>Foto</h2>
        <p>Na het uploaden kun je de foto verplaatsen in het canvas<span class="mobile-only"> (onderaan de pagina)</span> en schalen.</p>
        <p>Voor het beste resultaat: upload een afbeelding van minimaal {{ backgroundStore.canvasWidth }} × {{ backgroundStore.canvasHeight }} pixels.</p>
      </div>

      <ImagePicker/>
    </section>

    <section class="sidebar-form__section" style="view-transition-name: sidebar-form__section--color-scheme">
      <div class="sidebar-form__section-head">
        <h2>Kleurenschema</h2>
        <p>Probeer één van deze voorgestelde kleurencombinaties:</p>
      </div>

      <ColorSchemeSelector/>
    </section>

    <section class="sidebar-form__section" style="view-transition-name: sidebar-form__section--themes">
      <div class="sidebar-form__section-head">
        <h2>Thema’s</h2>
        <p>Kies drie unieke thema’s met een kleur per thema. Versleep ze om de volgorde te wijzigen.</p>
      </div>

      <ThemeSelectors/>
    </section>

    <section class="sidebar-form__section" style="view-transition-name: sidebar-form__section--export">
      <div class="sidebar-form__section-head">
        <h2>Exporteer</h2>
        <p>Er wordt altijd geëxporteerd als PNG op volledige kwaliteit.</p>
      </div>

      <ExportActions/>
    </section>
  </div>
</template>

<script setup lang="ts">
  import ColorSchemeSelector from '@/components/ColorSchemeSelector.vue';
  import ExportActions from '@/components/ExportActions.vue';
  import ImagePicker from '@/components/ImagePicker.vue';
  import ThemeSelectors from '@/components/ThemeSelectors.vue';
  import { useBackgroundStore } from '@/stores/useBackgroundStore';

  const backgroundStore = useBackgroundStore();
</script>

<style lang="scss">
  .sidebar-form {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .sidebar-form__section {
    padding-block: 30px;
    view-transition-class: sidebar-form__section;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }

    & + & {
      border-top: 2px solid color-opacity(--color-black, 5%);
    }

    &-head {
      margin-bottom: 18px;
      text-wrap: pretty;

      h2 {
        margin: 0 0 6px;
        font-size: 21px;
        line-height: 1.2;
        text-transform: var(--ui-text-transform);

        @include ui-headings-font;
      }

      p {
        margin: 0.5em 0;
        line-height: 1.45;
      }
    }
  }
</style>
